import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { WarrantyBadge } from "../icon";
const ProductGridBoxOEM = ({ itemin }) => {
  console.log("object", itemin);
  const view = "grid";
  const productUrl = `/hi-value-plus/product-detail/${itemin?.productSlug}`;
  return (
    <>
      <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded">
        <div className="position-relative">
          {itemin?.soldOut === 1 && (
            <div
              className="position-absolute text-white bgred rounded-1 px-2 z-3"
              style={{
                opacity: "1",
                top: view === "grid" ? "10px" : "80%",
                left: "10px",
              }}
            >
              Sold Out
            </div>
          )}
          {itemin?.warranty === 1 && (
            <div
              className="position-absolute object-fit-contain text-white rounded-1 px-2 z-3
             warranty-badge-wrapper"
              style={{
                top: view === "grid" ? "10px" : "0%",
                right: view === "grid" ? "10px" : "0px",
              }}
            >
              <WarrantyBadge
                months={itemin?.warrantyMonths}
                color={itemin?.soldOut === 1 ? "#ff000097" : "#FF0000"}
                size={60}
              />
            </div>

          )}
          {/* <div
                 className="f10 position-absolute"
                 style={{
                   bottom: view === "grid" ? "10px" : "0px",
                   left: "10px",
                   display: view === "grid" ? "block" : "none",
                 }}
               >
                 Posted On : {itemin?.postedOn}{" "}
               </div> */}
          {/* IMAGE */}
          <div
            className={`hiproduct-card__images rounded ${view === "grid" ? "w-100" : "me-3"
              }`}
          >
            <a href={productUrl} className="d-block h-100">
              <img
                alt={itemin?.name}
                className="img-fluid rounded w-100 h-100"
                src={itemin?.image}
              />
            </a>
          </div>
        </div>
        <div className="product-card__info mt-2">
          {/* <div className="product-card__meta d-none">
            <span className="product-card__meta-title">{itemin?.catLabel}</span>
          </div> */}
          <div className="hiproduct-card__name">
            <a
              href={`/hi-value-plus/product-detail/${itemin?.productSlug}`}
              className="  d-flex flex-column align-items-start align-items-md-center align-items-lg-center flex-lg-row flex-md-row gap-1"
            >
              {itemin?.name}   <span className="hispan txtlgeay fw-normal">(Refurbished Product)</span>
            </a>
          </div>
          <a
            href={`/hi-value-plus/product-detail/${itemin?.productSlug}`}
            className="hicategoryspan txtlgeay d-flex align-items-center gap-1 px-3"
          >
            {itemin?.categoryName}
          </a>
          {/* <div className="product-card__desc">{itemin?.shortDescription && itemin?.shortDescription != '' ? <>{itemin?.shortDescription}</> : <></>}</div> */}
          <div className="mt-0 mt-lg-2 ps-3 pe-3 text-truncate text-primary fw500 hicategoryspan">
            {itemin?.dealerName != "" ? (
              <> {itemin?.dealerName} | {itemin?.city}</>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/* <div className="product-card__footer"> */}
        {/* <div className="product-card__prices">
            <div className="product-card__price product-card__price--current"> */}
        {itemin?.price && itemin?.price != "0.00" ? (
          <>
            <div className="btn btn-sm  ps-3 pe-2 d-flex flex-column align-items-start align-items-md-center align-items-lg-center flex-lg-row flex-md-row hiproductprice fw500">
              <span className="d-flex align-items-center">

                <CurrencyRupeeIcon className="hiproductprice fw-bold " />
                {itemin?.price}
              </span>
              <span className="hiproductpricegst txtlgeay ms-1">(inclusive of GST)</span>
            </div>
          </>
        ) : (
          <>
            {/* <ProductNotifyOEM category={itemin?.catLabel} subCatLabel={itemin?.subCatLabel} mId={itemin?.manufacture?.manufactureId} model={itemin?.name} form='listPage' /> */}
            {/* <span className='btn btn-sm bglblue mb-1 mt-2 ps-2 pe-2 d-flex align-items-center f15 fw500'>
                                    Ask Price
                                </span> */}
          </>
        )}
        <div
          className="hiproductprice ps-3 pe-2 "
          style={{
            bottom: view === "grid" ? "10px" : "0px",
            //  left: "10px",
          }}
        >
          Posted On : {itemin?.postedOn}{" "}
        </div>
        {/* </div>
          </div> */}
        <div className="d-flex justify-content-center mt-0 mt-lg-2 mt-md-2">

          <a
            href={`/hi-value-plus/product-detail/${itemin?.productSlug}`}
            className="valueplussectionBtn    "
          >
            View Details
          </a>
        </div>
        {/* </div> */}
      </div>
    </>
  );
};

export default ProductGridBoxOEM;
